import { IQPPictureLoadCtrl } from "../qp-picture-loading";

export type ILoadState = "loading" | "loaded" | "loadfail";

export abstract class AbstractPictureState {
    // protected context: IQPPictureLoadCtrl;

    // 状态名称
    public abstract name: ILoadState;

    // 图片自身骨架屏样式
    public skeletonStyle: string = "qp-skeleton-loading";
    public animateClassHead: string = "qp-border-loading-";

    // public setContext(context: IQPPictureLoadCtrl) {
    //     this.context = context;
    // }

    private setBorderLoadingAnimate(animateClass: string, containerElem: JQLite, context: IQPPictureLoadCtrl) {
        // 获取容器宽高
        const containerWidth = containerElem[0].offsetWidth;
        const containerHeight = containerElem[0].offsetHeight;
        if (containerWidth == 0 || containerHeight == 0) {
            return;
        }
        // 创建容器边框动画效果
        const frameKey = context.id;
        const animateStyle = `
                <style>
                    @keyframes borderAround-${frameKey} {
                        0%,
                        100% {
                        clip: rect(0 ${containerWidth}px 0 0);
                        }
                        25% {
                        clip: rect(0 ${containerWidth}px ${containerHeight}px ${containerWidth}px);
                        }
                        50% {
                        clip: rect(${containerHeight}px ${containerWidth}px ${containerHeight}px 0);
                        }
                        75% {
                        clip: rect(0 0 ${containerHeight}px 0);
                        }
                    }

                    .${animateClass} {
                        display: inline-block;
                        position: relative;
                        border: 1px solid #eee;
                    }

                    .${animateClass}::before {
                        content: "";
                        position: absolute;
                        left: 0;
                        top: 0;
                        right: 0;
                        bottom: 0;
                        border: 2px solid #007abe;
                        animation: borderAround-${frameKey} 2.5s infinite linear;
                    }
                </style>`;

        // 动态加载动画样式
        $('head').append(animateStyle);
    }

    /**
     * @description 由于每个图片的容器大小都有可能不一样,因此每个图片容器都需要有一个独立的加载样式
     * @param containerElem 
     */
    public setLoadingClass(containerElem: JQLite, context: IQPPictureLoadCtrl) {
        const borderLoadingClass = `${this.animateClassHead}${context.id}`;
        // 设置loading动画
        this.setBorderLoadingAnimate(borderLoadingClass, containerElem, context);
    }

    /**
     * @description 设置当前状态样式,在切换状态后被调用
     */
    public abstract setStyle(imageElem: JQLite, context: IQPPictureLoadCtrl): void;

    /**
     * @description 清除当前状态样式,在切换状态前被调用
     */
    public abstract cleanStyle(imageElem: JQLite, context: IQPPictureLoadCtrl): void;

    /**
     * @description 设置当前状态下可用方法,在切换状态后被调用
     */
    public abstract setAction(imageElem: JQLite, context: IQPPictureLoadCtrl): void;


    /**
     * @description 清除当前状态下的特定方法,在切换状态前被调用
     */
    public abstract cleanAction(imageElem: JQLite, context: IQPPictureLoadCtrl): void;


}
